import api from "./axios";

export const getProjectWeather = async (projectId) => {
  try {
    const response = await api.get(`/weather/${projectId}/`);
    return response.data;
  } catch (error) {
    console.error("Weather fetch error:", error);
    return null;
  }
};

export const fetchProjects = async () => {
  return api.get("projects/list/");
};

export const getProjectDetail = (projectId) =>
  api.get(`project/info/${projectId}/`);


export const getProjectSummary = () =>
  api.get(`/project-summary/`,).then(res => res.data);


export const getProjectName = async (projectId) => {
  const res = await api.get(`/project-name/${projectId}/`);
  return res.data;
};


// safe_date 저장/업데이트(POST)
export const updateProjectSafeDate = (safe_date) =>
  console.log("API safe_date:", safe_date) ||
  api.post(`/safe-date/`, {
    safe_date,
  });

export const getProjectUsers = (projectId) =>
  api.get(`project/${projectId}/users/`);

export const getParticipantRoles = (projectId) =>
  api.get(`roles/`, { params: { project: projectId } });
